import React from 'react';
import { ChevronLeft, ChevronRight, X, Check } from 'lucide-react';

const TutorialStep = ({
  step,
  currentStep,
  totalSteps,
  onNext,
  onPrev,
  onSkip,
  isLastStep,
  isFirstStep
}) => {
  const positionClass = step.position || 'center';

  return (
    <div className={`tutorial-step animate-scaleIn tutorial-${positionClass}`}>
      <button className="tutorial-skip hover-scale" onClick={onSkip} title="Skip Tutorial">
        <X size={20} />
      </button>

      <div className="tutorial-icon">{step.icon}</div>

      <h2 className="tutorial-title">{step.title}</h2>
      <p className="tutorial-description">{step.description}</p>

      <div className="tutorial-step-counter">
        Step {currentStep} of {totalSteps}
      </div>

      <div className="tutorial-actions">
        {!isFirstStep && (
          <button className="tutorial-btn tutorial-btn-prev hover-lift" onClick={onPrev}>
            <ChevronLeft size={20} />
            Previous
          </button>
        )}

        <button 
          className={`tutorial-btn tutorial-btn-next hover-lift ${
            isLastStep ? 'tutorial-btn-complete' : ''
          }`}
          onClick={onNext}
        >
          {isLastStep ? (
            <>
              <Check size={20} />
              Get Started!
            </>
          ) : (
            <>
              Next
              <ChevronRight size={20} />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default TutorialStep;
